// extracted by mini-css-extract-plugin
var _1 = "CollectionsList_collections__19aad";
var _2 = "CollectionsList_empty__394a3";
var _3 = "CollectionsList_groupSearch__1509f";
var _4 = "CollectionsList_root__1c33c";
var _5 = "CollectionsList_tags__e3084";
export { _1 as "collections", _2 as "empty", _3 as "groupSearch", _4 as "root", _5 as "tags" }
